'use client';

function canUseBrowserRuntime() {
  return typeof window !== 'undefined';
}

function scrollWorkspaceRootIntoView() {
  if (!canUseBrowserRuntime()) {
    return false;
  }

  const workspaceRoot = document.querySelector<HTMLElement>(
    '[data-cms-workspace-root]'
  );
  if (!workspaceRoot) {
    return false;
  }

  workspaceRoot.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
  return true;
}

export function scrollCmsWorkspaceRootWhenReady() {
  if (!canUseBrowserRuntime() || scrollWorkspaceRootIntoView()) {
    return;
  }

  let attempts = 0;
  const tryScroll = () => {
    attempts += 1;
    if (scrollWorkspaceRootIntoView() || attempts >= 30) {
      return;
    }

    window.requestAnimationFrame(tryScroll);
  };

  window.requestAnimationFrame(tryScroll);
}
